import {
  Component,
  Input,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ILastDataBundle, ILastDataForm } from 'src/app/core/interfaces/shared/bundle/ILastData';

import { DynamicFormConfig, FieldConfig } from './dynamic-form-config.interface';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PantallasService } from 'src/app/core/http/apiProducto/pantallas.service';
import { skip } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GlobalDialogComponent } from '../globaldialog/globaldialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ICoverageDetails } from 'src/app/state/coverages/coverages.models';

@Component({
  exportAs: 'dynamicForm',
  // tslint:disable-next-line: component-selector
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {

  public _formConfig: DynamicFormConfig;

  errors: Array<any>;
  validations: Array<any>;

  @Input()
  set formConfig(form: DynamicFormConfig) {
    this._formConfig = form;
  }

  get formConfig(): DynamicFormConfig {
    return this._formConfig;
  }

  public form: FormGroup;

  get value(): ILastDataForm | any {
    return this.form.value;
  }

  constructor(
    private fb: FormBuilder, 
    private cdRef: ChangeDetectorRef, 
    private _bottomSheet: MatBottomSheet, 
    private pantallasService: PantallasService, 
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.errors = [];
    this.validations = [];
    this.form = this.createControl();
    this.form.statusChanges.subscribe(status => {
      const keys = Object.keys(this.form.controls);
      keys.forEach(key => {
        if (!this.form.controls[key].pristine && this.form.controls[key].status === 'INVALID') {
          this.errors.push({ [key]: this.form.controls[key].errors });
        }
      });
    })
  }

  saveValidationsErrors() {
    let errorMessages = [];
    this.errors.forEach(error => {
      this.validations.forEach(validation => {
        const errorKey = Object.getOwnPropertyNames(error);
        if (errorKey[0] === validation.name) {
          let validations = validation.validations;
          validations.forEach(val => {
            if (val.name === Object.getOwnPropertyNames(error[errorKey[0]])[0]) {
               errorMessages.push(val.message);
            }
          })
        }
      })
    })
    return errorMessages
  }

  setValues(newFormValues: ILastDataBundle | any): void {
    this.form.patchValue(newFormValues);
  }

  addNewFormConfig(form) {
    form.fields.forEach(field => {
      const control = this.fb.control(
        { value: field.value, disabled: field.disabled },
        this.bindValidations(field.validations || [])
      );
      this.form.addControl(field.name, control);
      this.validations.push({ name: field.name, validations: field.validations })
    });

    this._formConfig = form;
  }

  createControl(): FormGroup {
    const group = this.fb.group({});
    this._formConfig.fields.forEach(field => {
      const control = this.fb.control(
        { value: field.value, disabled: field.disabled },
        this.bindValidations(field.validations || [])
      );
      this.validations.push({ name: field.name, validations: field.validations })
      group.addControl(field.name, control);
    });

    return group;
  }

  bindValidations(validations: any): Validators | null {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });

      return Validators.compose(validList);
    }


    return null;
  }

  validateAllFormFields(formGroup: FormGroup): void {
    for (const [field] of Object.keys(formGroup.controls)) {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    }
  }

  getIcon(field) {
    return field.iconLabel;
  }

  show_popupInfo(fieldConfig: FieldConfig) {
    this.dialog.open(GlobalDialogComponent, {
      height: '300px',
      disableClose: true,
      panelClass: 'clientInfoPopup-panel',
      data: {
        title: fieldConfig.label,
        content: fieldConfig.info.content,
        info: true,
        closeIcon: true
      },
    });
  }

}

  // TEST CONFIG
  // @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  // dynamicForm: DynamicFormConfig = {
  //   fxLayout: 'row wrap',
  //   fxLayoutGap: '20px',
  //   fxLayoutAlign: 'center center',
  //   fields: [{
  //     type: 'input',
  //     label: 'item 1',
  //     spanLabel: 'item 1 label',
  //     inputType: 'number',
  //     value: 'test',
  //     fxFlex: {
  //       xs: 'calc(80% - 20px)',
  //       sm: '80',
  //       md: '40',
  //       gtMd: '100'

  //     },
  //     matFormFieldWidth: '100%',
  //     name: 'nombre',
  //     validations: [
  //       {
  //         name: 'required',
  //         validator: Validators.required,
  //         message: 'campo requerido'
  //       },
  //       {
  //         name: 'pattern',
  //         validator: Validators.pattern('^[a-zA-Z]+$'),
  //         message: '...'
  //       }
  //     ],
  //     suffix: {
  //       icon: true,
  //       text: 'euro_symbol'
  //     }
  //   },
  //   {
  //     type: 'input',
  //     label: 'item 2',
  //     spanLabel: 'item 2 label',
  //     inputType: 'email',
  //     fxFlex: {
  //       xs: 'calc(40% - 20px)',
  //       sm: '40',
  //       md: '40',
  //       gtMd: '100'

  //     },
  //     matFormFieldWidth: '100%',
  //     name: 'email',
  //     validations: [
  //       {
  //         name: 'required',
  //         validator: Validators.required,
  //         message: 'Email requerido'
  //       },
  //       {
  //         name: 'pattern',
  //         validator: Validators.pattern(
  //           '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$'
  //         ),
  //         message: 'Email no válido'
  //       }
  //     ]
  //   },
  //   {
  //     type: 'date',
  //     label: 'item 3',
  //     spanLabel: 'item 3 label',
  //     fxFlex: {
  //       xs: 'calc(40% - 20px)',
  //       sm: '40',
  //       md: '40',
  //       gtMd: '100'
  //     },
  //     name: 'aaas',
  //     matFormFieldWidth: '100%',
  //     validations: [
  //       {
  //         name: 'required',
  //         validator: Validators.required,
  //         message: 'fecha requerido'
  //       }
  //     ]
  //   },
  //   {
  //     type: 'input',
  //     label: 'item 4',
  //     spanLabel: 'item 4 label',
  //     inputType: 'text',
  //     fxFlex: {
  //       xs: 'calc(100% - 20px)',
  //       sm: '70',
  //       md: '100',
  //       gtMd: '100'
  //     },
  //     name: 'asd',
  //     matFormFieldWidth: '100%',
  //     validations: [
  //       {
  //         name: 'required',
  //         validator: Validators.required,
  //         message: 'nombre requerido'
  //       },
  //       {
  //         name: 'pattern',
  //         validator: Validators.pattern('^[a-zA-Z]+$'),
  //         message: '...'
  //       }
  //     ]
  //   },
  //   {
  //     type: 'checkbox',
  //     label: 'Soy residente en españa',
  //     value: true,
  //     fxFlex:  {
  //       xs: 'calc(80% - 20px)'
  //     },
  //     name: 'residenteEspanya',
  //     validations: [
  //       {
  //         name: 'required',
  //         validator: Validators.required,
  //         message: ' Este campo es requerido'
  //       }
  //     ]

  //   }
  // ]};


